/**
 * API manzili uch bosqichda aniqlanadi:
 *   1. `public/config.js` dagi `window.__XSIB_API_BASE__` — serverda
 *      tahrirlanadi, build qayta yig'ilmaydi (alohida subdomen uchun)
 *   2. `VITE_API_BASE_URL` — build vaqtidagi qiymat
 *   3. bo'sh — so'rovlar "/api/..." ga ketadi (dev'da Vite proxy,
 *      serverda nginx backend'ga uzatadi)
 *
 * ⚠️ NEGA ALOHIDA MODUL. Bu qiymat IKKI axios nusxasiga kerak:
 * `api` (odatiy so'rovlar) va `refreshClient` (`sessionRefresh.ts` —
 * tokenni yangilash, ATAYLAB interceptorsiz). Ikkinchisi birinchisidan
 * import qila olmaydi: aylanma bog'liqlik hosil bo'lardi (`client.ts` →
 * `sessionRefresh.ts` → `client.ts`). Qiymatni ikki joyda takrorlash esa
 * ertaga ajralib ketardi — panel bir manzilga, tokenni yangilash boshqasiga
 * borardi va nosozlik faqat 30 daqiqadan keyin ko'rinardi.
 */
declare global {
  interface Window {
    __XSIB_API_BASE__?: string
  }
}

const runtimeBase = typeof window !== 'undefined' ? window.__XSIB_API_BASE__ : undefined

export const apiBaseUrl = (runtimeBase ?? import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '')

/**
 * So'rov timeout'i — `api` va `refreshClient` uchun bir xil.
 *
 * ⚠️ MAJBURIY: axios'da standart `timeout` — `0`, ya'ni cheksiz kutish.
 * Server javob bermasa promise HECH QACHON rad etilmaydi, `.catch(...)`
 * ishlamaydi va ekran abadiy "yuklanmoqda" holatida qoladi. Amalda
 * ushlangan: tashkilot tanlash kartasi bosilgach `loading` holatida
 * qolib ketgan — kod mantig'ida emas, aynan shu sababdan.
 *
 * 15 sekund — `xsib-portal` dagi bilan bir xil (izchillik uchun).
 */
export const API_TIMEOUT_MS = 15_000
